import Navigator from "../../../component/navigator";
import styles from "./index.module.scss";
import { getTasks } from "../../../api/task";
import { Loading } from "@quark/design";
import TaskItem from "./task-item";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { usePagination } from "ahooks";

const TaskList = () => {
  const fetchTasks = ({ current, pageSize }: { current: number; pageSize: number }) => {
    return getTasks({ page: current, page_size: pageSize })
      .then((res) => {
        return {
          total: res.count,
          list: res.results,
        }
      })
  }

  const { data, loading, pagination, refresh } = usePagination(fetchTasks);
  const { total = 0, list: tasks = [] } = data || {};

  return (
    <div className={styles.container}>
      <Navigator />
      <div className={styles.content}>
        {loading ? <Loading /> : (
          <>
            {tasks.map((task) => {
              return (
                <TaskItem
                  task={task}
                  key={task.id}
                  onClose={refresh}
                />
              )
            })}
          </>
        )}
      </div>
      <div className={styles.footer}>
        <Pagination
          showTotal={(total) => `共 ${total} 个任务`}
          total={total}
          pageSize={pagination.pageSize}
          current={pagination.current}
          showSizeChanger
          onChange={pagination.onChange}
        />
      </div>
    </div>
  )
}

export default TaskList;
